import React from "react";
import propTypes from "prop-types";
import snakeCase from "lodash/snakeCase";

import { Redirect, useRouteMatch } from "react-router-dom";

import Modal from "react-bootstrap/cjs/Modal";
import HelpNavigation from "../../navigation/HelpNavigation";
import Breadcrumb from "react-bootstrap/cjs/Breadcrumb";
import { LinkContainer } from "react-router-bootstrap";

import classes from "./HelpModal.module.css";

import helpPagination from "data/helpPagination";

const HelpModal = ({ show, onHide }) => {
  const helpRoute = useRouteMatch({
    path: "/help",
  });

  const helpPageRoute = useRouteMatch({
    path: "/help/:page",
  });

  const helpSubPageRoute = useRouteMatch({
    path: "/help/:page/:subpage",
  });

  const helpSubSubPageRoute = useRouteMatch({
    path: "/help/:page/:subpage/:subsubpage",
  });

  let redirect = null;

  const helpPage = helpPageRoute
    ? helpPagination.find((page) => snakeCase(page.title) === helpPageRoute.params.page)
    : null;

  // redirect from the help base page
  if (helpRoute && !helpPage) {
    redirect = <Redirect to={`/help/${snakeCase(helpPagination[0].title)}`} />;
  }

  const helpSubPage =
    helpSubPageRoute && helpPage
      ? helpPage.subpages.find(
          (subpage) => snakeCase(subpage.title) === helpSubPageRoute.params.subpage
        )
      : null;

  // redirect if at a top-level page with subpages
  if (helpRoute && helpPage && helpPage.subpages && helpPage.subpages.length && !helpSubPage) {
    redirect = (
      <Redirect
        to={`/help/${snakeCase(helpPage.title)}/${snakeCase(helpPage.subpages[0].title)}`}
      />
    );
  }

  const helpSubSubPage =
    helpSubSubPageRoute && helpSubPage
      ? helpSubPage.subpages.find(
          (subsubpage) => snakeCase(subsubpage.title) === helpSubSubPageRoute.params.subsubpage
        )
      : null;

  const Breadcrumbs = () => (
    <Breadcrumb>
      <LinkContainer exact to={"/help"}>
        <Breadcrumb.Item href={"/help"}>Help</Breadcrumb.Item>
      </LinkContainer>
      {helpPage ? (
        <LinkContainer exact to={helpPageRoute.url}>
          <Breadcrumb.Item>{helpPage.title}</Breadcrumb.Item>
        </LinkContainer>
      ) : null}
      {helpSubPage ? (
        <LinkContainer exact to={helpSubPageRoute.url}>
          <Breadcrumb.Item>{helpSubPage.title}</Breadcrumb.Item>
        </LinkContainer>
      ) : null}
      {helpSubSubPage ? (
        <LinkContainer exact to={helpSubSubPageRoute.url}>
          <Breadcrumb.Item>{helpSubSubPage.title}</Breadcrumb.Item>
        </LinkContainer>
      ) : null}
    </Breadcrumb>
  );

  const content =
    helpSubSubPage && helpSubSubPage.content
      ? helpSubSubPage.content
      : helpSubPage && helpSubPage.content
      ? helpSubPage.content
      : helpPage && helpPage.content
      ? helpPage.content
      : null;

  return (
    <>
      {redirect}
      <Modal show={show} onHide={onHide} dialogClassName={classes.HelpModal} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>ILX Portal Administration Help</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HelpNavigation pagination={helpPagination} />
          <Breadcrumbs />
          {content}
        </Modal.Body>
      </Modal>
    </>
  );
};

HelpModal.propTypes = {
  show: propTypes.bool.isRequired,
  onHide: propTypes.func,
};

HelpModal.defaultProps = {
  show: false,
};

export default HelpModal;
